/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: wboCjrKjkicgLwUG7d8r4V
// Component: XBLIF8bf7Q7W

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicReview.module.css"; // plasmic-import: XBLIF8bf7Q7W/css

import StarSvgIcon from "../credit_storm_2_redesigned/icons/PlasmicIcon__StarSvg"; // plasmic-import: wf0Y7SiG9qtu/icon

createPlasmicElementProxy;

export type PlasmicReview__VariantMembers = {};
export type PlasmicReview__VariantsArgs = {};
type VariantPropType = keyof PlasmicReview__VariantsArgs;
export const PlasmicReview__VariantProps = new Array<VariantPropType>();

export type PlasmicReview__ArgsType = {
  slot3?: React.ReactNode;
  children?: React.ReactNode;
  slot2?: React.ReactNode;
};
type ArgPropType = keyof PlasmicReview__ArgsType;
export const PlasmicReview__ArgProps = new Array<ArgPropType>(
  "slot3",
  "children",
  "slot2"
);

export type PlasmicReview__OverridesType = {
  root?: Flex__<"div">;
};

export interface DefaultReviewProps {
  slot3?: React.ReactNode;
  children?: React.ReactNode;
  slot2?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicReview__RenderFunc(props: {
  variants: PlasmicReview__VariantsArgs;
  args: PlasmicReview__ArgsType;
  overrides: PlasmicReview__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "variable",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_wboCjrKjkicgLwUG7d8r4V",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      onPointerOver={async event => {
        const $steps = {};

        $steps["updateVariant"] = true
          ? (() => {
              const actionArgs = {};
              return (({ vgroup, value }) => {
                if (typeof value === "string") {
                  value = [value];
                }
                undefined;
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["updateVariant"] != null &&
          typeof $steps["updateVariant"] === "object" &&
          typeof $steps["updateVariant"].then === "function"
        ) {
          $steps["updateVariant"] = await $steps["updateVariant"];
        }
      }}
    >
      <div className={classNames("all", sty.freeBox__ey73D)}>
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <StarSvgIcon
                className={classNames("all", sty.svg__dx5P7)}
                role={"img"}
              />

              <StarSvgIcon
                className={classNames("all", sty.svg__na4Ng)}
                role={"img"}
              />

              <StarSvgIcon
                className={classNames("all", sty.svg__eEam)}
                role={"img"}
              />

              <StarSvgIcon
                className={classNames("all", sty.svg___0H4Lx)}
                role={"img"}
              />

              <StarSvgIcon
                className={classNames("all", sty.svg__cbgTr)}
                role={"img"}
              />
            </React.Fragment>
          ),
          value: args.slot3
        })}
      </div>
      <div className={classNames("all", sty.freeBox__jHv8Y)}>
        {renderPlasmicSlot({
          defaultContents:
            "Nem\u00e1m vysok\u00fd p\u0159\u00edjem, tak\u017ee jsem ne\u010dekal, \u017ee mi n\u011bkdo p\u016fj\u010d\u00ed. Ale tady mi to fakt na\u0161lo nab\u00eddku, kterou jsem mohl v pohod\u011b zvl\u00e1dnout. V\u0161echno online, bez zbyte\u010dn\u00e9ho b\u011bh\u00e1n\u00ed a vysv\u011btlov\u00e1n\u00ed. D\u00edk!",
          value: args.children,
          className: classNames(sty.slotTargetChildren)
        })}
      </div>
      <div className={classNames("all", sty.freeBox__pZuId)}>
        <div className={classNames("all", sty.freeBox___1QaD)}>
          {renderPlasmicSlot({
            defaultContents: "Roman T., 32 let",
            value: args.slot2,
            className: classNames(sty.slotTargetSlot2)
          })}
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicReview__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicReview__VariantsArgs;
    args?: PlasmicReview__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicReview__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicReview__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicReview__ArgProps,
          internalVariantPropNames: PlasmicReview__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicReview__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicReview";
  } else {
    func.displayName = `PlasmicReview.${nodeName}`;
  }
  return func;
}

export const PlasmicReview = Object.assign(
  // Top-level PlasmicReview renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicReview
    internalVariantProps: PlasmicReview__VariantProps,
    internalArgProps: PlasmicReview__ArgProps
  }
);

export default PlasmicReview;
/* prettier-ignore-end */
